import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { Endpoint } from '@business/api/endpoint';
import { initBlocs } from '@business/blocs';
import { registerBlocs } from '@business/blocs/register';
import { CommonService } from '@business/services';
import { AppConfig } from '@core/utils/config';
import { R } from '@core/utils/r';
import { ignoreError } from '@core/utils/rxjs/operators';
import { Session } from '@modules/auth/session';
import React from 'react';
import { render } from 'react-dom';
import { finalize, tap, switchMap } from 'rxjs/operators';
import { createRoot } from 'react-dom/client';
import App from './App';

export function boot() {
  registerBlocs();

  initializeAppId();

  restoreSession();

  Bugsnag.start({
    apiKey: '6fe481acc8aee1a2c928e33dd6ea05f8',
    plugins: [new BugsnagPluginReact()],
    autoDetectErrors: false,
    autoTrackSessions: false,
    onError: function (event) {
      if (Session.user) {
        event.setUser(Session.user.id, Session.user.email, CommonService.getFullName(Session.user));
      }
      event.addMetadata('company', {
        appId: AppConfig.current().appId,
        companyId: AppConfig.current().companyId,
      });
    },
  });
}

function renderApp() {
  const root = createRoot(document.getElementById('root'));

  root.render(<App />);
}

function restoreSession() {
  Session.restore().pipe(tap(initBlocs), ignoreError(), finalize(renderApp)).subscribe();
}

export function initializeAppId() {
  let appId = document.querySelector("meta[name='tenant']")!.getAttribute('content');
  const config = AppConfig.get();
  if (R.isEmpty(appId)) {
    appId = config.appId || '';
  }
  AppConfig.set({ appId });
  Endpoint.setAppId(appId);
  Endpoint.setCompanyId(config.companyId);
}
